var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFacebookinline = function SvgFacebookinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 21,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m10.648 11.75.547-3.594H7.72V5.812c0-1.015.468-1.953 2.031-1.953h1.602V.773S9.906.5 8.539.5C5.688.5 3.813 2.258 3.813 5.383v2.773H.608v3.594h3.204v8.75h3.906v-8.75h2.93Z",
    fill: "currentColor"
  })));
};
export default SvgFacebookinline;